import browserInfo from 'browser-info';

export const state = () => ({
  name: null,
  version: null,
  os: null,
});

export const mutations = {
  setName(st, name) {
    st.name = name;
  },
  setVersion(st, version) {
    st.version = version;
  },
  setOs(st, os) {
    st.os = os;
  },
};

export const actions = {
  assignBrowserInfo({ commit }) {
    const { name, version, os } = browserInfo();
    commit('setName', name);
    commit('setVersion', version);
    commit('setOs', os);
  },
};

export const storeModule = {
  namespaced: true,
  state,
  mutations,
  actions,
};

export default (store) => {
  store.registerModule('browser', storeModule);
};
